import React, { useState, useEffect, useContext } from "react";
import "./JobsCard.css";
import inactiveBulb from "../../Assets/Images/inactiveBulb.png";
import activeBulb from "../../Assets/Images/activeBulb.png";
import locationIconLight from "../../Assets/Images/job-location-icon-light.svg";
import locationIconDark from "../../Assets/Images/job-location-icon-dark.svg";
import Button from "../Button/Button";
import assignCandidateArrowIcon from "../../Assets/Images/assign-candidate-arrow-icon.png";
import CustomTooltip from "../../Common/Tooltip/Tooltip";
import CriticalIcon from "../../Assets/Images/critical-icon.svg";
import HighIcon from "../../Assets/Images/high-icon.svg";
import LowIcon from "../../Assets/Images/low-icon.svg";
import MediumIcon from "../../Assets/Images/medium-icon.svg";
import {
  applyEllipsis,
  toCapitalize,
} from "../Common-Function/CommonFunctions";
import { ConfirmationPopup } from "../PopupStyles/PopupComponent";
import { put, get } from "../../helper/Api_helper";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import {
  VYLABS_BASE_URL,
  UPDATE_JOBS_STATUS,
  CREATE_JOB_URL,
} from "../../helper/url_helper";
import shareJobIcon from "../../Assets/Images/job-share-icon.svg";
import ExperienceIconLight from "../../Assets/Images/exp-job-icon-light.svg";
import ExperienceIconDark from "../../Assets/Images/exp-job-icon-dark.svg";
import { CopyLinkPopup } from "../../Common/PopupStyles/PopupComponent";
import { debounce } from "lodash";
import { DynamicContext } from "../../Context/DynamicContext";
import ReactDOM from "react-dom";

let globalStatusUpdatePopup = {
  isOpen: false,
  jobId: null,
  isActive: false,
  title: "",
  onConfirm: () => {},
  onClose: () => {},
};

const showStatusUpdatePopup = (config) => {
  globalStatusUpdatePopup = {
    ...globalStatusUpdatePopup,
    ...config,
    isOpen: true,
  };

  document.dispatchEvent(
    new CustomEvent("jobStatusUpdatePopupChanged", {
      detail: globalStatusUpdatePopup,
    }),
  );
};

const hideStatusUpdatePopup = () => {
  globalStatusUpdatePopup = {
    ...globalStatusUpdatePopup,
    isOpen: false,
  };

  document.dispatchEvent(
    new CustomEvent("jobStatusUpdatePopupChanged", {
      detail: globalStatusUpdatePopup,
    }),
  );
};

const JobStatusUpdatePopup = () => {
  const [popupState, setPopupState] = useState(globalStatusUpdatePopup);
  React.useEffect(() => {
    const handlePopupChange = (e) => {
      setPopupState(e.detail);
    };

    document.addEventListener("jobStatusUpdatePopupChanged", handlePopupChange);
    return () => {
      document.removeEventListener(
        "jobStatusUpdatePopupChanged",
        handlePopupChange,
      );
    };
  }, []);

  if (!popupState.isOpen) return null;

  return (
    <ConfirmationPopup
      isOpen={popupState.isOpen}
      onClose={popupState.onClose}
      onConfirm={popupState.onConfirm}
      title="Job Status Update"
      subTitle="Confirmation required"
      message={
        <>
          Are you sure you want to set{" "}
          <span style={{ color: "#6860ee", fontWeight: "bold" }}>
            "{popupState.title}"
          </span>{" "}
          job to {popupState.isActive ? "inactive" : "active"}?
        </>
      }
      confirmLabel={popupState.isActive ? "Set Inactive" : "Set Active"}
      cancelLabel="Cancel"
    />
  );
};

document.addEventListener("DOMContentLoaded", () => {
  const popupRoot = document.createElement("div");
  popupRoot.id = "job-status-update-popup-root";
  document.body.appendChild(popupRoot);
});

const JobsCard = ({
  title,
  subTitle,
  minSalary,
  maxSalary,
  location,
  minYearsExperience,
  maxYearsExperience,
  experience,
  jobtype,
  client,
  jobRole,
  priority,
  client_contact_person,
  actionText,
  viewJobEventHandler = () => {},
  assignCandidateEventHandler = () => {},
  isActive: initialIsActive = false,
  viewJob = "View Job",
  jobId,
  onStatusToggle = () => {},
  isSelectMode = false,
  isSelected = false,
  handleCardSelect = () => {},
  matchPercentage,
  fitness,
}) => {
  const { userDetails, isDarkMode } = useContext(DynamicContext);
  const [isActive, setIsActive] = useState(initialIsActive);
  const [sharePopup, setSharePopup] = useState({
    isOpen: false,
    link: "",
    isLoading: false,
  });
  document.addEventListener("DOMContentLoaded", () => {
    const portalRoot = document.getElementById("portal-root");
    if (!portalRoot) {
      const newPortalRoot = document.createElement("div");
      newPortalRoot.id = "portal-root";
      document.body.appendChild(newPortalRoot);
    }
  });
  const [ellipsisLength, setEllipsisLength] = useState(() => {
    if (window.innerWidth > 2290) return 80;
    if (window.innerWidth <= 2290 && window.innerWidth >= 1660) return 50;
    if (window.innerWidth <= 1660 && window.innerWidth >= 425) return 30;
    if (window.innerWidth < 950) return 20;
    return 28;
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 2290) {
        setEllipsisLength(80);
      } else if (window.innerWidth <= 2290 && window.innerWidth >= 1660) {
        setEllipsisLength(50);
      } else if (window.innerWidth <= 1660 && window.innerWidth >= 425) {
        setEllipsisLength(30);
      } else if (window.innerWidth < 950) {
        setEllipsisLength(20);
      } else {
        setEllipsisLength(28);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const jobData = {
    title,
    subTitle,
    location,
    priority,
    salary_min: minSalary,
    salary_max: maxSalary,
  };
  const handleStatusToggle = () => {
    showStatusUpdatePopup({
      jobId,
      isActive,
      title,
      onConfirm: handleJobStatus,
      onClose: () => hideStatusUpdatePopup(),
    });
  };

  const handleJobStatus = async () => {
    if (!jobId) {
      console.error("Job ID is required to toggle status.");
      return;
    }

    try {
      const response = await put(
        VYLABS_BASE_URL,
        `${UPDATE_JOBS_STATUS}?id=${jobId}&active=${!isActive}`,
      );
      setIsActive(!isActive);
      onStatusToggle(!isActive, jobId);
      Toast("success", "Job status updated successfully");
    } catch (error) {
      console.error("Error updating job status:", error);
      Toast("error", "Failed to update job status");
    } finally {
      hideStatusUpdatePopup();
    }
  };

  const handleShareLink = debounce(
    async (jobId) => {
      if (!jobId || !userDetails?.id) {
        console.error("Job ID or User ID is missing.");
        return;
      }
      setSharePopup((prev) => ({ ...prev, isLoading: true }));
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${CREATE_JOB_URL}?id=${jobId}`,
        );
        if (response && response.share_url) {
          setSharePopup({
            isOpen: true,
            link: response.share_url,
            isLoading: false,
          });
        } else {
          setSharePopup({
            isOpen: true,
            link: "",
            isLoading: false,
          });
        }
      } catch (error) {
        console.error("Error creating job URL:", error);
        Toast("error", "Failed to create job URL");
        setSharePopup((prev) => ({ ...prev, isLoading: false }));
      }
    },
    300,
    { leading: true, trailing: false },
  );
  // Prefer the backend re-ranker's fitness tier when present; otherwise fall
  // back to the match_percentage threshold so non-reranked surfaces are
  // unchanged.
  const tierMeta = getJobFitMetaFromTier(fitness);
  const fitMeta = tierMeta || getMatchFitLabelAndColor(matchPercentage);
  const priorityMeta = getPriorityMeta(priority);
  const hasFit =
    tierMeta != null ||
    (matchPercentage !== undefined && matchPercentage !== null);
  return (
    <>
      <div
        className="jobs-card-container"
        style={{
          borderColor: hasFit ? fitMeta.color : "var(--card__border)",
          borderWidth: "1px",
          borderStyle: "solid",
        }}
      >
        <div className="jobs-card-header">
          <CustomTooltip title={title || "N/A"} arrow placement="top">
            <div className="job-header-icon-container" style={{ minWidth: 0 }}>
              {isSelectMode && (
                <div
                  className="selection-checkbox"
                  onClick={(e) => e.stopPropagation()}
                  style={{ marginRight: "10px" }}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleCardSelect();
                    }}
                  />
                </div>
              )}
              <div>
                <h3 className="jobs-card-title">
                  {applyEllipsis(jobRole || "N/A", ellipsisLength)}
                </h3>
                <div className="job-headers-spans">
                  <span className="headers-client-span">
                    {toCapitalize(client || "N/A")} ({" "}
                    {toCapitalize(client_contact_person)} )
                  </span>
                </div>
              </div>
            </div>
          </CustomTooltip>
          <div
            style={{
              display: "grid",
              gap: "15px",
            }}
          >
            {hasFit && (
              <div
                className="job-match-percentage"
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  zIndex: 2,
                }}
              >
                <span
                  style={{
                    backgroundColor: fitMeta.color,
                    color: "#fff",
                    padding: "6px 12px",
                    borderTopRightRadius: "12px",
                    borderBottomLeftRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "500",
                    textTransform: "capitalize",
                    display: "inline-block",
                    minWidth: "10px",
                    textAlign: "center",
                  }}
                >
                  {fitMeta.label}
                </span>
              </div>
            )}
            <div className="job-card-right-icons">
              {priorityMeta?.icon && (
                <CustomTooltip title={priorityMeta.label} arrow placement="top">
                  <img
                    className="job-priority-icon"
                    src={priorityMeta.icon}
                    alt={priorityMeta.label}
                  />
                </CustomTooltip>
              )}
              <img
                src={isActive ? activeBulb : inactiveBulb}
                alt={isActive ? "active-bulb" : "inactive-bulb"}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleStatusToggle();
                }}
              ></img>
              {isActive ? (
                <img
                  src={shareJobIcon}
                  alt="shareJobIcon"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShareLink(jobId);
                  }}
                />
              ) : null}
            </div>
          </div>
        </div>
        <div className="jobs-card-info">
          <div className="jobs-card-info-details">
            <img
              src={isDarkMode ? ExperienceIconDark : ExperienceIconLight}
              alt="experience-icon"
              className=""
            />
            <span>
              {minYearsExperience !== undefined &&
              minYearsExperience !== null &&
              minYearsExperience !== ""
                ? maxYearsExperience !== undefined &&
                  maxYearsExperience !== null &&
                  maxYearsExperience !== ""
                  ? `${minYearsExperience} - ${maxYearsExperience} Years`
                  : `${minYearsExperience} Years`
                : maxYearsExperience !== undefined &&
                    maxYearsExperience !== null &&
                    maxYearsExperience !== ""
                  ? `${maxYearsExperience} Years`
                  : experience
                    ? `${experience} Years`
                    : "N/A"}
            </span>
          </div>
          <div className="jobs-card-info-details">
            <img
              src={isDarkMode ? locationIconDark : locationIconLight}
              alt="location-icon"
              className=""
            />
            <span>
              {applyEllipsis(toCapitalize(location), 25)}{" "}
              {jobtype && (
                <span>( {toCapitalize(jobtype || "N/A")} )</span>
              )}{" "}
            </span>
          </div>
        </div>
        {actionText && (
          <div className="jobs-card-action">
            <Button
              label={viewJob}
              event={viewJobEventHandler}
              backgroundColor="var(--body__background)"
              color="#6860EE"
              border="1px solid #6860EE"
              style={{ padding: "8px 12px" }}
              className="view-job"
            />
            <Button
              label={"Assigned Candidates"}
              event={assignCandidateEventHandler}
              iconSrc={assignCandidateArrowIcon}
              iconPosition="right"
              backgroundColor="var(--body__background)"
              color="#6860EE"
              border="1px solid #6860EE"
              style={{ padding: "8px 12px" }}
              iconWidth="6px"
              className="assign-candidate"
            />
          </div>
        )}
      </div>
      {ReactDOM.createPortal(
        <CopyLinkPopup
          isOpen={sharePopup.isOpen}
          onClose={() =>
            setSharePopup({ isOpen: false, link: "", isLoading: false })
          }
          title="Share This Job"
          link={sharePopup.link}
          isLoading={sharePopup.isLoading}
          jobData={jobData}
        />,
        document.getElementById("portal-root"),
      )}
    </>
  );
};

const getMatchFitLabelAndColor = (percentage) => {
  const val = parseFloat(percentage);
  if (isNaN(val)) {
    return { label: "N/A", color: "var(--header__color)" };
  }
  if (val >= 90) return { label: "Top Fit", color: "#22C55E" };
  if (val >= 66) return { label: "Good Fit", color: "#3B82F6" };
  if (val >= 33) return { label: "Partial Fit", color: "#F59E0B" };
  return { label: "Unlikely Fit", color: "#EF4444" };
};

const getPriorityMeta = (priority) => {
  if (priority === undefined || priority === null || priority === "") {
    return null;
  }

  const normalizedPriority = String(priority).trim().toLowerCase();

  switch (normalizedPriority) {
    case "1":
    case "critical":
      return { label: "Critical Priority", color: "#EF4444", icon: CriticalIcon };
    case "2":
    case "high":
      return { label: "High Priority", color: "#22C55E", icon: HighIcon };
    case "3":
    case "medium":
      return { label: "Medium Priority", color: "#3B82F6", icon: MediumIcon };
    case "4":
    case "low":
      return { label: "Low Priority", color: "#F59E0B", icon: LowIcon };
    case "n/a":
    case "na":
      return { label: "N/A", color: "#6B7280" };
    default:
      return { label: String(priority), color: "#6B7280" };
  }
};

// Maps a backend re-ranker fitness tier to the same label/color the threshold
// logic above produces, so the badge looks identical regardless of source.
// Returns null for an absent/unknown tier so callers fall back to the threshold.
const getJobFitMetaFromTier = (tier) => {
  switch ((tier || "").toLowerCase()) {
    case "top":
      return { label: "Top Fit", color: "#22C55E" };
    case "good":
      return { label: "Good Fit", color: "#3B82F6" };
    case "partial":
      return { label: "Partial Fit", color: "#F59E0B" };
    case "unlikely":
      return { label: "Unlikely Fit", color: "#EF4444" };
    default:
      return null;
  }
};

export { JobStatusUpdatePopup };
export default JobsCard;
